import {geocodingCacheTemplateURL} from "../others/Configuration";
import $ from "jquery";

export default {
  init: function (options) {

  },
  set(term, value) {
    return $.post(geocodingCacheTemplateURL({term}), value, "json");
  },
  get(term) {
    return $.get(geocodingCacheTemplateURL({term}), {}, "json");
  }
};
